import styled from "styled-components";

export default styled.div`

&{
  width: 100%;
  height: 100%;
}
main{
  display: flex;
}

h1{
  font-size: 1.5em;
  font-weight: 400;
}
button{
  margin-top: 20px;
  margin-bottom: 20px;
}

.userInfo {
  display:flex;
  width: auto;
  flex-direction: column;
  justify-content: center;
  flex: 0 2 300px;
}

.test{
  overflow-wrap: break-word;
  word-break: break-all;
  line-break: loose;
}

.headerInfo{
  display:flex;
  justify-content: flex-start;
  align-items: center;
  gap: 60px;
}

#externalSync{
  background-color: ${props => props.theme.colors.green_dark};
}

.sectionLabel{
  font-weight: 400;
  margin-top: 20px;
  margin-bottom: 10px;
  width:100%;
}

.delimiter{
  background-color: ${props => props.theme.colors.primary};
  height: 2px;
  border: 0px;
  margin-left: 10px;
  width:calc(100% - 20px);
  width:100%;
}

`